/* Linda's Look – Home sections behavior: tabs, quick add, wishlist hearts, announcement rotation.
   Safe to include several times (guarded). No dependencies. */
(function () {
  if (window.LLHome) return;
  window.LLHome = { version: '1.0.0' };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var WISH_KEY = 'll-wishlist';

  function readWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; } }
  function writeWish(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {} }

  function initWishlist(scope) {
    var list = readWish();
    (scope || document).querySelectorAll('[data-llh-wish]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-llh-wish')) > -1 ? 'true' : 'false');
    });
  }

  function selectTab(tab) {
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    list.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }

  var rotators = [];
  function initAnnouncements(scope) {
    (scope || document).querySelectorAll('[data-llh-rotate]').forEach(function (bar) {
      if (bar.__llRot) return;
      var items = bar.querySelectorAll('.llh-announce__item');
      if (items.length < 2) return;
      var i = 0, speed = (parseInt(bar.getAttribute('data-llh-rotate'), 10) || 4) * 1000;
      bar.__llRot = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
      rotators.push(bar);
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-llh-tab]');
    if (tab) { selectTab(tab); return; }
    var heart = e.target.closest('[data-llh-wish]');
    if (heart) {
      e.preventDefault();
      var id = heart.getAttribute('data-llh-wish'), list = readWish(), idx = list.indexOf(id);
      if (idx > -1) list.splice(idx, 1); else list.push(id);
      writeWish(list);
      initWishlist();
      // Same storage key + event as ll-collection.js, so hearts stay in sync across the site.
      document.dispatchEvent(new CustomEvent('ll:wishlist', { detail: { handle: id, saved: idx === -1, list: list } }));
    }
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-llh-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    var n = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(n + tabs.length) % tabs.length];
    next.focus(); selectTab(next);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-llh-quick-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    var msg = form.querySelector('.llh-card__msg');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var after = form.getAttribute('data-llh-redirect') || 'drawer';
    var data = new FormData(form);
    // Ask Shopify to re-render the Horizon cart sections so the drawer updates (same approach as ll-collection.js).
    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id], [data-ll-cart-section]').forEach(function (el) {
      var sid = el.dataset.sectionId || el.dataset.llCartSection;
      if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
    });
    if (sectionIds.length) data.append('sections', sectionIds.slice(0, 5).join(','));
    fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
        if (after === 'cart') { window.location.href = root + 'cart'; return; }
        if (btn) { btn.innerHTML = btn.getAttribute('data-added') || 'Added ✓'; }
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var idInput = form.querySelector('[name="id"]');
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
              resource: cart, sourceId: form.id || 'llh-quick-add',
              data: { source: 'llh-quick-add', itemCount: cart.item_count, variantId: idInput ? String(idInput.value) : '', sections: res.json.sections || {} }
            } }));
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) { el.textContent = cart.item_count; });
            if (after === 'drawer') {
              var drawer = document.querySelector('cart-drawer-component');
              if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) drawer.open();
            }
            document.dispatchEvent(new CustomEvent('ll:cart:add', { detail: res.json }));
          })
          .finally(function () {
            setTimeout(function () { if (btn) { btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy'); } }, 1800);
          });
      })
      .catch(function (err) {
        if (btn) { btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (msg) { msg.textContent = err.message; msg.hidden = false; } else { form.submit(); }
      });
  });

  function init(scope) { initWishlist(scope); initAnnouncements(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
